import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

type RejectArticleDialogProps = {
  open: boolean
  rejectComment: string
  onClose: () => void
  onReject: () => void
  setRejectComment: (value: string) => void
}

export function RejectArticleDialog({
  open,
  rejectComment,
  onClose,
  onReject,
  setRejectComment,
}: RejectArticleDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reject - Return to Draft</DialogTitle>
      <DialogContent>
        <TextField
          label="Reason (optional)"
          multiline
          rows={3}
          fullWidth
          sx={{ mt: 1 }}
          value={rejectComment}
          onChange={event => setRejectComment(event.target.value)}
          placeholder="Optional explanation for the author..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onReject}>
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  )
}
